// When each fragment of the makers' words is found (the words themselves are
// in src/config/fragments.ts).

import { FRAGMENT_IDS, type FragmentId } from "../config/fragments.ts"
import { ALL_RITE_IDS, pointOfRite, TERNION_ID, type RiteId } from "./rite.ts"
import { isSolved } from "./lattice.ts"
import { keysOf, type Millis, type Progress } from "./progress.ts"
import type { Trit } from "./rings.ts"
import { ORDER_SLOTS } from "./order.ts"

const layer = (z: Trit): readonly RiteId[] => ALL_RITE_IDS.filter((id) => pointOfRite(id)[2] === z)
const allWon = (p: Progress, ids: readonly RiteId[]): boolean => ids.every((id) => isSolved(p, id))

const FOUND = {
  first: (p) => isSolved(p, "000"),
  still: (p) => allWon(p, layer(0)),
  sink: (p) => allWon(p, layer(-1)),
  rise: (p) => allWon(p, layer(1)),
  whole: (p) => p.solved[TERNION_ID] !== undefined,
  order: (p) => keysOf(p.order).length >= ORDER_SLOTS,
} as const satisfies Record<FragmentId, (p: Progress) => boolean>

export type Finding = { readonly progress: Progress; readonly found: readonly FragmentId[] }

// Mark fragments found since last asked.
export const findFragments = (progress: Progress, now: Millis): Finding => {
  const found = FRAGMENT_IDS.filter((id) => progress.fragments[id] === undefined && FOUND[id](progress))
  if (found.length === 0) return { progress, found }
  const stamped = Object.fromEntries(found.map((id) => [id, now] as const))
  return { progress: { ...progress, fragments: { ...progress.fragments, ...stamped } }, found }
}
